export const ROLE_DESTINATIONS = {
  "Campaign Manager": "/campaign",
  "Marketing Manager": "/marketing",
  "Offering Manager": "/offerings",
  "Communications Manager": "/content",
  "BU Head": "/businessunits",
  "CMO/CXO": "/dashboard",
  "Approver": "/dashboard",
  "Guest Access": "/home/campaign",
};

export function roleDestination(role) {
  return ROLE_DESTINATIONS[role] || null;
}

export function workspaceForRole(role) {
  return role === "CMO/CXO" || role === "Approver" ? "approver" : "user";
}

export function defaultAssignedRole(roles, userType) {
  if (userType === "admin") return "";
  if (userType === "CMO/CXO" && roles.includes("CMO/CXO")) return "CMO/CXO";
  if (userType === "approver" && roles.includes("Marketing Manager")) return "Marketing Manager";
  if (userType === "user" && roles.includes("Campaign Manager")) return "Campaign Manager";
  return roles.find((role) => roleDestination(role)) || "";
}
